import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit } = measures

export const revealButton = css`
  position: absolute;
  top: 0;
  bottom: 0;
  right: ${unit}px;
`

export const password = css`
  padding-right: ${4 * unit}px;
`
